document.addEventListener("DOMContentLoaded", function () {
  const submenuItems = document.querySelectorAll(".exist_inner_submenu");
  const noSubmenuItems = document.querySelectorAll(".without_submenu");

  submenuItems.forEach(function (submenu) {
    submenu.addEventListener("mouseenter", function () {
      submenuItems.forEach((item) => item.classList.remove("active"));
      submenu.classList.add("active");

      const parentMegamenu = submenu.closest(".megamenu-main");
      if (parentMegamenu) {
        parentMegamenu.classList.add("hover-active");
      }
    });
  });

  noSubmenuItems.forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      document
        .querySelectorAll(".megamenu-main.hover-active")
        .forEach((el) => el.classList.remove("hover-active"));
      submenuItems.forEach((el) => el.classList.remove("active"));
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".mobile-menu_accordion");

  accordions.forEach((accordion) => {
    const header = accordion.querySelector(".mm_accordion-header");
    const content = accordion.querySelector(".mm_accordion-content");

    header.addEventListener("click", () => {
      // Close all other accordions if you want only one open at a time
      accordions.forEach((item) => {
        if (item !== accordion) {
          item.querySelector(".mm_accordion-content").style.display = "none";
          item.classList.remove("active");
        }
      });

      // Toggle current
      const isOpen = content.style.display === "block";
      content.style.display = isOpen ? "none" : "block";
      accordion.classList.toggle("active", !isOpen);
    });
  });
});
